module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAA7ElEQVRYR+2XQQrCMBBF/zQWdx6nCxeCPUShRaX1IF14EBWVFnqICi5ceBx3UpMKbQXdJlkEOrP/k583ySchOF7kuD+wQdMJMcFxEAyTTQA5iU13a1Uv3mVdnB7dGQyTbSrgHawuYNhMQmV1sT+yQV2QTFCX3FfHBK0SXEVR/KTpzrSpTf2sfeWXqiq7mGnnSCHgVA5CIqM7+hxkgzqzZ4I61H41THBcBM8iBoRTQQ3InNZyCOqrn8Jz68EKpTJaNkNQs0GNG8MENaD9SZigVYI3P4D0HPu4q5IWTf9xd7nYoOl0mCATNCVgqv8AM5mmKU1G6SYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/germany.png
// module id = fb5z
// module chunks = 2